import React from 'react';
import { Route } from 'react-router-dom';
import { Col, Row } from '@saucelabs/sl-component-grid';

import { HeaderLogo } from '../../../../web-ui/src/dashboard/components/HeaderLogo';
import {
  SALES_CONTACT_FORM,
  SALES_CONTACT_NUMBER,
  SALES_CONTACT_NUMBER_READABLE,
} from './../../constants';
import { EVENTS, trackEvent } from './../../tracking';
import Styles from './ContainerRoute.styles';

const ContainerRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(routeProps) => (
      <div className={Styles.container}>
        <Row
          between="xs"
          className={Styles.header}
          middle="xs"
        >
          <Col
            start="xs"
            xs
          >
            <div className="ml-2 max-w-min h-7 flex flex-row items-center">
              <HeaderLogo />
            </div>
          </Col>
          <Col
            className={Styles['right-column']}
            end="xs"
            xs
          >
            Need pricing help?
            {' '}
            <a
              href={SALES_CONTACT_FORM}
              onClick={() => trackEvent(EVENTS.CONTACT_SALES, { type: 'nav' })}
              rel="noreferrer"
              target="_blank"
            >
              Contact sales
            </a>
            {' '}
            or call
            {' '}
            <a
              href={`tel:${SALES_CONTACT_NUMBER}`}
              onClick={() => trackEvent(EVENTS.CONTACT_SALES, { type: 'nav-phone' })}
            >
              {SALES_CONTACT_NUMBER_READABLE}
            </a>
          </Col>
        </Row>
        <Component {...routeProps} />
      </div>
    )}
  />
);

ContainerRoute.propTypes = Route.propTypes;

export default ContainerRoute;
